const headRowsSupport = {
  file: 'Archivo',
  updatedAt: 'Modificado en',
  size: 'Tamaño',
  download: 'Descargar',
  type: 'Visibilidad',
  description: 'Descripción',
  admin: 'Editar'
};

export default headRowsSupport;
